import React from 'react';
import { FormGroup } from './FormGroup';

interface Props {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export function MfaTokenInput({ value, onChange, disabled }: Props) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/[^0-9]/g, '').slice(0, 7);
    onChange(raw);
  };

  const display = value.length > 2
    ? `${value.slice(0, 2)}-${value.slice(2, 5)}${value.length > 5 ? '-' + value.slice(5, 7) : ''}`
    : value;

  return (
    <FormGroup label="Authy Token" htmlFor="mfa-token">
      <input
        id="mfa-token"
        type="text"
        className="form-control"
        placeholder="XX-XXX-XX"
        value={display}
        onChange={handleChange}
        disabled={disabled}
        maxLength={9}
        autoFocus
      />
    </FormGroup>
  );
}
